/* eslint-disable */
const invalidUSRegions = [684,264,268,242,246,441,284,345,767,809,829,849,473,671,876,658,664,670,787,939,869,758,784,721,868,649,340]
export default invalidUSRegions
